import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25424f9b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block block-file mb-4" }
const _hoisted_2 = { class: "file-container" }
const _hoisted_3 = {
  ref: "pdfContainer",
  class: "pdf-view"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, null, 512)
    ])
  ]))
}